import FlagElement from './FlagElement';

export default FlagElement;
